var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareableLinksApiService } from '../../sharing/links/shareable-links-api.service';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { PreviewFilesService } from 'common/file-preview/preview-files.service';
import { Settings } from 'common/core/config/settings.service';
import { CurrentUser } from 'common/auth/current-user';
import { filter, map } from 'rxjs/operators';
import { Toast } from 'common/core/ui/toast.service';
import { Store } from '@ngxs/store';
import { DownloadEntries } from '../../state/actions/commands';
var LinkPreviewContainerComponent = /** @class */ (function () {
    function LinkPreviewContainerComponent(store, route, links, previewFiles, settings, currentUser, router, toast, el) {
        this.store = store;
        this.route = route;
        this.links = links;
        this.previewFiles = previewFiles;
        this.settings = settings;
        this.currentUser = currentUser;
        this.router = router;
        this.toast = toast;
        this.el = el;
        this.data$ = new BehaviorSubject(null);
        this.passwordPanelVisible$ = new BehaviorSubject(false);
    }
    Object.defineProperty(LinkPreviewContainerComponent.prototype, "entryAlreadyImported$", {
        /**
         * Check if current user owns this entry or
         * already has it imported into their drive.
         */
        get: function () {
            var userId = this.currentUser.get('id');
            return this.data$.pipe(map(function (data) { return data.link; }), filter(function (link) { return !!link && !!link.entry && !!link.entry.users; }), map(function (link) { return link.entry; }), map(function (entry) { return !!entry.users.find(function (user) { return user.id === userId; }); }));
        },
        enumerable: true,
        configurable: true
    });
    LinkPreviewContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bindToDownload();
        this.disableContextMenu();
        this.route.params.subscribe(function (params) {
            _this.links.findByHash(params.hash, { withEntries: true }).subscribe(function (response) {
                _this.data$.next(response);
                _this.setBackgroundClass(response.link);
                if (response.link.password) {
                    _this.togglePasswordPanel(true);
                }
                else {
                    _this.togglePasswordPanel(false);
                    _this.showPreview();
                }
            }, function () {
                _this.router.navigate(['/404']);
            });
        });
    };
    LinkPreviewContainerComponent.prototype.ngOnDestroy = function () {
        this.downloadSub.unsubscribe();
    };
    LinkPreviewContainerComponent.prototype.import = function () {
        var _this = this;
        this.links.importEntry(this.data$.value.link.id, this.password)
            .subscribe(function (response) {
            var link = _this.data$.value.link;
            link.entry.users = response.users;
            _this.data$.next(__assign({}, _this.data$.value, { link: link }));
            _this.toast.open({
                message: "\":name\" imported into your drive.",
                replacements: { name: link.entry.name },
            });
        });
    };
    LinkPreviewContainerComponent.prototype.togglePasswordPanel = function (value) {
        this.passwordPanelVisible$.next(value);
    };
    LinkPreviewContainerComponent.prototype.bindToDownload = function () {
        var _this = this;
        this.downloadSub = this.previewFiles.download.subscribe(function () {
            var link = _this.data$.value.link;
            _this.store.dispatch(new DownloadEntries([link.entry], link, _this.password));
        });
    };
    /**
     * Show preview for shareable link files.
     */
    LinkPreviewContainerComponent.prototype.showPreview = function () {
        var data = this.data$.value;
        data.link.entry.url += "?shareable_link=" + data.link.id;
        if (this.password) {
            data.link.entry.url += "&password=" + this.password;
        }
        this.data$.next(__assign({}, data));
    };
    LinkPreviewContainerComponent.prototype.setValidPassword = function (password) {
        this.password = password;
        this.showPreview();
        this.togglePasswordPanel(false);
    };
    LinkPreviewContainerComponent.prototype.setBackgroundClass = function (link) {
        var className = link.entry.type === 'folder' ? 'folder-link' : 'file-link';
        this.el.nativeElement.classList.add(className);
    };
    LinkPreviewContainerComponent.prototype.disableContextMenu = function () {
        fromEvent(this.el.nativeElement, 'contextmenu')
            .subscribe(function (e) {
            e.preventDefault();
        });
    };
    return LinkPreviewContainerComponent;
}());
export { LinkPreviewContainerComponent };
